import { Container, Typography } from "@mui/material";
import { Carousel } from "3d-react-carousal";
import Partner from "./partnerImage.png";
import { Box } from "@mui/system";
import img1 from "./img1.jpeg";
import img2 from "./img2.jpeg";
import img3 from "./img3.jpeg";
export default () => {
  let slides = [
    <img src={img1} alt="1" />,
    <img src={img2} alt="2" />,
    <img src={img3} alt="3" />,
  ];
  const sectionHeading = "SNEAK PEAK";
  return (
    <Box pt={15} id="sneakpeak">
      <Container sx={{ zIndex: "1" }}>
        <Box sx={{ position: "relative", textAlign: "center" }} mb={10}>
          <Box>
            <span className="textStroke">
              <Typography
                color="white"
                fontSize={{ xs: "31px", sm: "50px", md: "74px" }}
                sx={{ letterSpacing: "0.12em" }}
              >
                {sectionHeading}
              </Typography>
            </span>
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: "10%",
              right: 0,
              left: 0,
              margin: "auto",
            }}
          >
            <Typography
              color="white"
              fontSize={{ xs: "25px", sm: "40px", md: "64px" }}
              sx={{ letterSpacing: "0.12em" }}
            >
              {sectionHeading}
            </Typography>
          </Box>
        </Box>
      </Container>
      <Box maxWidth="md" margin="auto">
        {/* <center><h4 style={{color:'red'}}>Which image was disscussed ? Let me know </h4></center> */}
        {/* <img src={Partner} alt={Partner} width="100%" /> */}
        <Carousel slides={slides} autoplay={true} interval={2000} />
      </Box>
    </Box>
  );
};
